<template>
	<div class="page-content__content">
		<div class="admin-store">
			<StoreTable/>
		</div>
	</div>
</template>

<script>
import StoreTable from "@/components/sections/Store/StoreTable.vue";

export default {
	name: "StoreGroups",
	components: {StoreTable},
}
</script>

